import { SceneData } from '@/schemas/sceneDataSchema';
import { useSceneStore } from './scene-store';

export function applyStepData(stepData?: SceneData['step_state']) {
  if (!stepData?.scene_data) return;
  useSceneStore.getState().applySceneData(stepData.scene_data);
}

export function applyPersistData(stepData: SceneData['step_state'], persistedKeys: string[]) {
  if (!stepData?.scene_data) return;
  useSceneStore.getState().mergeSceneData(stepData.scene_data, persistedKeys);
}
